import React, { useEffect, useReducer, useState } from "react";
import {
  convertWorkStatusViaKey,
  convertWorkStatusViaName,
  createUserModelObj,
  getGenderType,
  getGenderTypesList,
  getLanguage,
  getUserRoleObjectForName,
  getUserRolesList,
  getUserStatusList,
  getUserToggleArray,
  getUserToggleWithKey,
  noneBranchObject,
} from "../Managers/dataProvider";
import {
  BranchModel,
  EnumAlertDialogType,
  EnumPopupFunctions,
  EnumUserAcces,
  EnumUserStatus,
  PopupInfoModel,
  PreferredTimeModel,
  UserModel,
} from "../Managers/dataStructures";
import {
  fetchUserPrefDayTime,
  postUserOnServer,
  sendJoinRequestToTeamLead,
  timeout,
  updatePrefTime,
  updateUserInfo,
} from "../Managers/wepApiManager";
import {
  ActivityIndicator,
  NegativeToast,
  PositiveToast,
  Toast,
} from "../Managers/utilityComponents";
import {
  getAuthToken,
  getCurrentCurrency,
  getCurrentUser,
  getEncryptionKey,
  getUserAccess,
  saveProfileData,
} from "../Managers/profileManager";
import {
  checkEntity,
  isValiEmail,
  makeRandomID,
} from "../Managers/utilityFunctions";
import bcrypt from "bcryptjs";
interface UserDetailProps {
  user?: UserModel;
  fType: EnumPopupFunctions;
  closePopup?: () => void;
  closeSelfEdit?: () => void;
  popupItem?: PopupInfoModel;
  array_branches: BranchModel[];
}

export default function UserDetail(props: UserDetailProps) {
  const isEnglish = getLanguage();
  const [userDetails, setUserDetail] = useState<UserModel>(
    props.user !== undefined
      ? structuredClone(props.user)
      : createUserModelObj()
  );
  const [team_lead, setTeamLead] = useState<string>();
  //structuredClone(props.user)
  //JSON.parse(JSON.stringify(props.user))
  const [issActivityIndicator, setIsActivityIndicator] =
    useState<boolean>(false);
  const [toastText, setToastText] = useState<string>("");
  const [isToastVisible, setIsToastVisible] = useState<EnumAlertDialogType>(
    EnumAlertDialogType.NEUTRAL
  );
  const [isJoiningRequest, setIsJoiningRequest] = useState<boolean>(false);
  const [joinRequestToast, setJoinRequestToast] = useState<EnumAlertDialogType>(
    EnumAlertDialogType.NEUTRAL
  );
  const [joinRequestMessage, setjoinRequestMessage] = useState<string>("");
  const [, forceUpdate] = useReducer((x: number) => x + 1, 0);

  const access: EnumUserAcces = getUserAccess();

  useEffect(() => {
    fetchUserPrefDayTime(
      userDetails,
      (array_prefDayTime: PreferredTimeModel[]) => {
        let tempDetail = userDetails;
        tempDetail.pref_time = array_prefDayTime;
        setUserDetail(tempDetail);
        forceUpdate();
      }
    );
  }, [userDetails]);

  const isDisabled: boolean =
    props.fType === EnumPopupFunctions.USER_DETAIL ? true : false;
  const isPrefTimeDisabled: boolean =
    access === EnumUserAcces.ADMIN ? (isDisabled ? true : false) : true;
  function onCancel() {
    if (props.closePopup !== undefined) {
      props.closePopup();
    } else if (props.closeSelfEdit !== undefined) {
      props.closeSelfEdit();
    }
  }

  function onSave() {
    if (checkFormFields() === false) {
      return;
    }
    if (props.fType === EnumPopupFunctions.EDIT_USER) {
      setIsActivityIndicator(true);
      updateUserInfo(userDetails, (isSuccess: any) => {
        setIsActivityIndicator(false);
        if (isSuccess) {
          //updatge current info if user is self
          if (userDetails.user_id === getCurrentUser().user_id) {
            userDetails.password = getCurrentUser().password;
            const auth_token = getAuthToken();
            saveProfileData(auth_token, userDetails);
          }

          updatePrefTime(userDetails, (pref_time: PreferredTimeModel[]) => {
            userDetails.pref_time = pref_time;
          });
          if (props.popupItem !== undefined) {
            if (props.popupItem.callback !== undefined) {
              props.popupItem?.callback(userDetails);
            }
          }
          showAlert(
            true,
            isEnglish
              ? "Success: User information updated"
              : "Erfolg: Benutzerinformationen wurden aktualisiert.",
            () => {
              if (props.closePopup !== undefined) {
                props.closePopup();
              }
            }
          );
        } else {
          showAlert(
            false,
            isEnglish
              ? "Error: Unable to Access server."
              : "Fehler: Serverzugriff fehlgeschlagen.",
            () => {}
          );
        }
      });
    } else if (props.fType === EnumPopupFunctions.ADD_USER) {
      setIsActivityIndicator(true);
      const randPass: string = makeRandomID(5);
      bcrypt.hash(
        randPass,
        getEncryptionKey(),
        (herr: Error | null, hash: string) => {
          if (herr == null) {
            userDetails.password = hash;
            postUserOnServer(
              userDetails,
              randPass,
              (isSuccess: boolean, user_id: string, message: string) => {
                setIsActivityIndicator(false);
                if (isSuccess) {
                  let tempDetail = userDetails;
                  tempDetail.user_id = user_id;
                  setUserDetail(tempDetail);
                  updatePrefTime(
                    tempDetail,
                    (pref_time: PreferredTimeModel[]) => {
                      let t2Detail = userDetails;
                      t2Detail.pref_time = pref_time;
                      setUserDetail(t2Detail);
                    }
                  );
                  if (props.popupItem !== undefined) {
                    if (props.popupItem.callback !== undefined) {
                      props.popupItem?.callback(userDetails);
                    }
                  }
                  showAlert(
                    true,
                    isEnglish
                      ? "Success: New User created."
                      : "Erfolg: Neuer Benutzer erstellt.",
                    () => {
                      if (props.closePopup !== undefined) {
                        props.closePopup();
                      } else if (props.closeSelfEdit !== undefined) {
                        props.closeSelfEdit();
                      }
                    }
                  );
                } else {
                  showAlert(false, "Fehler: " + message, () => {});
                }
              }
            );
          } else {
            console.log("hashError=" + herr);
            showAlert(
              false,
              isEnglish
                ? "Error: Failed to generate user password."
                : "Fehler: Benutzerpasswort konnte nicht generiert werden.",
              () => {}
            );
          }
        }
      );
    }
  }

  function checkFormFields() {
    if (checkEntity(userDetails.email_id) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid email ID." : "Ungültige E-Mail-Adresse.",
        () => {}
      );
      return false;
    } else if (isValiEmail(userDetails.email_id) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid email ID." : "Ungültige E-Mail-Adresse.",
        () => {}
      );
      return false;
    }
    if (checkEntity(userDetails.employee_id) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid employee ID." : "Ungültige Mitarbeiter-ID.",
        () => {}
      );
      return false;
    }
    if (checkEntity(userDetails.first_name) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid first name." : "Ungültiger Vorname.",
        () => {}
      );
      return false;
    }
    if (checkEntity(userDetails.last_name) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid last name." : "Ungültiger Nachname",
        () => {}
      );
      return false;
    }
    /*
    if (checkEntity(userDetails.mobilePrefix) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid mobile number." : "Ungültige Mobilnummer.",
        () => {}
      );
      return false;
    }
    if (checkEntity(userDetails.mobile) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid mobile number." : "Ungültige Mobilnummer.",
        () => {}
      );
      return false;
    }

    if (checkEntity(userDetails.address) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid address." : "Ungültige Adresse.",
        () => {}
      );
      return false;
    }
    if (checkEntity(userDetails.user_city) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid city." : "Ungültige Stadt.",
        () => {}
      );
      return false;
    }
    if (checkEntity(userDetails.user_zipcode) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid zipcode." : "Ungültige Postleitzahl.",
        () => {}
      );
      return false;
    }
    if (checkEntity(userDetails.user_state) === false) {
      showAlert(
        false,
        isEnglish ? "Invalid state." : "Ungültiger Bundesstaat.",
        () => {}
      );
      return false;
    }*/
    if (userDetails.working_status.status === EnumUserStatus.UNKNOWN) {
      showAlert(
        false,
        isEnglish ? "Invalid working status." : "Ungültiger Arbeitsstatus.",
        () => {}
      );
      return false;
    }
    if (userDetails.role === undefined) {
      showAlert(
        false,
        isEnglish ? "Assign user type." : "Benutzertyp zuweisen.",
        () => {}
      );
      return false;
    } else if (userDetails.role.type === EnumUserAcces.UNKNOWN) {
      showAlert(
        false,
        isEnglish ? "Assign user type." : "Benutzertyp zuweisen",
        () => {}
      );
      return false;
    }

    return true;
  }

  async function showAlert(
    isPositive: boolean,
    text: string,
    callback: () => void
  ) {
    setToastText(text);
    if (isPositive) {
      setIsToastVisible(EnumAlertDialogType.POSITIVE);
    } else {
      setIsToastVisible(EnumAlertDialogType.NEGATIVE);
    }
    await timeout(2000);
    setIsToastVisible(EnumAlertDialogType.NEUTRAL);
    callback();
  }

  function onChangetTime(item: PreferredTimeModel[]) {
    let tempDetail = userDetails;
    tempDetail.pref_time = item;
    setUserDetail(tempDetail);
    forceUpdate();
  }

  function onBranchChange(value: string) {
    const sIndex: number = props.array_branches.findIndex(
      (x) => x.name === value
    );
    if (sIndex !== -1) {
      let tempDetail = userDetails;
      tempDetail.permanant_branch = props.array_branches[sIndex];
      setUserDetail(tempDetail);
      //forceUpdate();
    }
  }

  function onWorkStatusChange(value_: string) {
    let tempDetail = userDetails;
    tempDetail.working_status = convertWorkStatusViaName(value_);
    setUserDetail(tempDetail);
  }

  function onRoleChange(value_: string) {
    const tempDetail = userDetails;
    tempDetail.role = getUserRoleObjectForName(value_);
    setUserDetail(tempDetail);
  }

  function onUserToggle(value_: string) {
    const tempDetail = userDetails;
    tempDetail.toggleAbility = getUserToggleWithKey(value_);
    setUserDetail(tempDetail);
  }

  function onTeamLeadChange(value: string) {
    setTeamLead(value);
  }

  function sendRequest() {
    if (team_lead !== undefined) {
      setIsJoiningRequest(true);
      sendJoinRequestToTeamLead(
        team_lead,
        getCurrentUser().user_id,
        (isSuccess: boolean, message: string) => {
          setIsJoiningRequest(false);
          if (isSuccess) {
            setTeamLead(undefined);
          } else {
            setjoinRequestMessage(message);
          }
          showJoinToast(isSuccess, () => {});
        }
      );
    }
  }

  async function showJoinToast(isPositive: boolean, callback: () => void) {
    if (isPositive) {
      setJoinRequestToast(EnumAlertDialogType.POSITIVE);
    } else {
      setJoinRequestToast(EnumAlertDialogType.NEGATIVE);
    }

    await timeout(2000);
    setJoinRequestToast(EnumAlertDialogType.NEUTRAL);
    callback();
  }
  return (
    <div>
      <div className="space-y-12">
        <div className="border-b border-gray-900/10 pb-12">
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            {isEnglish ? "Profile" : "Profil"}
          </h2>
          <p className="mt-1 text-sm leading-6 text-gray-600">
            {isEnglish
              ? "This information will be displayed publicly so be careful what you share."
              : "Anwenderprofil Füllen Sie bitte die untenstehenden Felder aus."}
          </p>

          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-4">
              <label
                htmlFor="username"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "Username / Email" : "Benutzername / E-Mail"}
              </label>
              <div className="mt-2">
                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                  <input
                    type="text"
                    name="username"
                    id="username"
                    autoComplete="username"
                    onChange={(x) =>
                      (userDetails.email_id = x.currentTarget.value)
                    }
                    defaultValue={
                      props.fType === EnumPopupFunctions.ADD_USER
                        ? undefined
                        : userDetails?.email_id
                    }
                    className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                    placeholder="User Name / Email"
                    disabled={isDisabled}
                  />
                </div>
              </div>
            </div>
            <div className="sm:col-span-4">
              <label
                htmlFor="username"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "Employee ID" : "Mitarbeiter ID"}
              </label>
              <div className="mt-2">
                <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                  <input
                    type="text"
                    name="employee-id"
                    id="employee-id"
                    autoComplete="employee-id"
                    onChange={(x) =>
                      (userDetails.employee_id = x.currentTarget.value)
                    }
                    defaultValue={
                      props.fType === EnumPopupFunctions.ADD_USER
                        ? undefined
                        : userDetails?.employee_id
                    }
                    className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                    placeholder={isEnglish ? "Employee ID" : "Mitarbeiter ID"}
                    disabled={isPrefTimeDisabled}
                  />
                </div>
                {/* <button
                  type="button"
                  disabled={isDisabled}
                  onClick={onChangePassword}
                  className="mt-5 rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  Change Password
                </button> */}
              </div>
            </div>
            <div className="col-span-full">
              <label
                htmlFor="about"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "About" : "Über mich…"}
              </label>
              <div className="mt-2">
                <textarea
                  id="about"
                  name="about"
                  rows={3}
                  disabled={isDisabled}
                  onChange={(x) => {
                    userDetails.about_us = x.currentTarget.value;
                    setUserDetail(userDetails);
                  }}
                  className="block w-full rounded-md border-0 py-1.5 pl-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                >
                  {userDetails.about_us}
                </textarea>
              </div>
              <p className="mt-3 text-sm leading-6 text-gray-600">
                {isEnglish
                  ? "Write a few sentences about yourself."
                  : "Hier kannst du etwas über dich selbst schreiben."}
              </p>
            </div>

            <div className="col-span-full">
              <label
                htmlFor="photo"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "Photo" : "Bild"}
              </label>
              <div className="mt-2 flex items-center gap-x-3">
                <svg
                  className="h-24 w-24 text-gray-300"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                  />
                </svg>
                <button
                  type="button"
                  disabled={isDisabled}
                  className="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  {isEnglish ? "Change" : "Ändern"}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-b border-gray-900/10 pb-12">
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            {isEnglish ? "Personal Information" : ""}
          </h2>
          <p className="mt-1 text-sm leading-6 text-gray-600">
            {isEnglish
              ? "Use a permanent address where you can receive mail."
              : "Bitte aktuelle Adresse eintragen"}
          </p>

          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-3">
              <label
                htmlFor="first-name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "First name" : "Vorname"}
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  name="first-name"
                  id="first-name"
                  autoComplete="given-name"
                  disabled={isDisabled}
                  className="block w-full pl-1 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  onChange={(x) =>
                    (userDetails.first_name = x.currentTarget.value)
                  }
                  defaultValue={
                    props.fType === EnumPopupFunctions.ADD_USER
                      ? undefined
                      : userDetails?.first_name
                  }
                />
              </div>
            </div>

            <div className="sm:col-span-3">
              <label
                htmlFor="last-name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "Last name" : "Nachname"}
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  name="last-name"
                  id="last-name"
                  autoComplete="family-name"
                  disabled={isDisabled}
                  className="block w-full pl-1 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  onChange={(x) =>
                    (userDetails.last_name = x.currentTarget.value)
                  }
                  defaultValue={
                    props.fType === EnumPopupFunctions.ADD_USER
                      ? undefined
                      : userDetails?.last_name
                  }
                />
              </div>
            </div>

            <div className="sm:col-span-4">
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "Mobile" : "Handy"}
              </label>
              <div className="flex flex-row">
                <div className="mt-2">
                  <input
                    id="mobile-prefix"
                    name="mobile"
                    type="mobile"
                    placeholder="+XX"
                    disabled={isDisabled}
                    className="block w-10 pl-1 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(x) =>
                      x.currentTarget.value.length <= 3
                        ? (userDetails.mobilePrefix = x.currentTarget.value)
                        : (x.currentTarget.value = x.currentTarget.value.slice(
                            0,
                            3
                          ))
                    }
                    defaultValue={
                      props.fType === EnumPopupFunctions.ADD_USER
                        ? undefined
                        : userDetails?.mobilePrefix
                    }
                  />
                </div>
                <div className="mt-2 pl-1">
                  <input
                    id="mobile"
                    name="mobile"
                    type="mobile"
                    placeholder="XXXXXXXXXX"
                    disabled={isDisabled}
                    className="block pl-1 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    onChange={(x) =>
                      (userDetails.mobile = x.currentTarget.value)
                    }
                    defaultValue={
                      props.fType === EnumPopupFunctions.ADD_USER
                        ? undefined
                        : userDetails?.mobile
                    }
                  />
                </div>
              </div>
            </div>

            <div className="sm:col-span-3">
              <label
                htmlFor="gender-label"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "Gender" : "Geschlecht"}
              </label>
              <div className="mt-2">
                <select
                  id="gender"
                  name="gender"
                  autoComplete="gender"
                  disabled={isDisabled}
                  defaultValue={
                    getGenderType(userDetails.gender.key).display_name
                  }
                  onChange={(x) =>
                    (userDetails.gender = getGenderType(x.currentTarget.value))
                  }
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                >
                  {getGenderTypesList().map((x) => [
                    <option key={x.key}>{x.display_name}</option>,
                  ])}
                </select>
              </div>
            </div>
            <div className="col-span-full">
              <label
                htmlFor="street-address"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "Address" : "Adresse"}
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  name="street-address"
                  id="street-address"
                  autoComplete="street-address"
                  disabled={isDisabled}
                  className="block w-full rounded-md pl-1 border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  onChange={(x) =>
                    (userDetails.address = x.currentTarget.value)
                  }
                  defaultValue={
                    props.fType === EnumPopupFunctions.ADD_USER
                      ? undefined
                      : userDetails?.address
                  }
                />
              </div>
            </div>

            <div className="sm:col-span-2 sm:col-start-1">
              <label
                htmlFor="city"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "City" : "Stadt"}
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  name="city"
                  id="city"
                  autoComplete="address-level2"
                  disabled={isDisabled}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  onChange={(x) =>
                    (userDetails.user_city = x.currentTarget.value)
                  }
                  defaultValue={
                    props.fType === EnumPopupFunctions.ADD_USER
                      ? undefined
                      : userDetails?.user_city
                  }
                />
              </div>
            </div>

            <div className="sm:col-span-2">
              <label
                htmlFor="region"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "State / Province" : "Land"}
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  name="region"
                  id="region"
                  autoComplete="address-level1"
                  disabled={isDisabled}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  onChange={(x) =>
                    (userDetails.user_state = x.currentTarget.value)
                  }
                  defaultValue={
                    props.fType === EnumPopupFunctions.ADD_USER
                      ? undefined
                      : userDetails?.user_state
                  }
                />
              </div>
            </div>

            <div className="sm:col-span-2">
              <label
                htmlFor="postal-code"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "ZIP / Postal code" : "PLZ"}
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  name="postal-code"
                  id="postal-code"
                  autoComplete="postal-code"
                  disabled={isDisabled}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  onChange={(x) =>
                    (userDetails.user_zipcode = x.currentTarget.value)
                  }
                  defaultValue={
                    props.fType === EnumPopupFunctions.ADD_USER
                      ? undefined
                      : userDetails?.user_zipcode
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="border-b border-gray-900/10 pb-12">
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            {isEnglish ? "Work Preferences" : "Gewünschte Arbeitszeiten"}
          </h2>
          <p className="mt-1 text-sm leading-6 text-gray-600">
            {isEnglish
              ? "Set your work Preferences here."
              : "Tragen Sie bitte hier die gewünschten Arbeitszeiten ein."}
          </p>

          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-3">
              <label
                htmlFor="working-status-label"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "Working Status" : "Arbeitsstatus"}
              </label>
              <div className="mt-2">
                <select
                  id="working-status"
                  name="working-status"
                  autoComplete="country-name"
                  disabled={isPrefTimeDisabled}
                  defaultValue={
                    convertWorkStatusViaKey(userDetails.working_status.key)
                      .display_name
                  }
                  onChange={(x) => onWorkStatusChange(x.currentTarget.value)}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
                >
                  {getUserStatusList().map((x) => [
                    <option key={x.key}>{x.display_name}</option>,
                  ])}
                </select>
              </div>
            </div>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="col-span-full">
              <label
                htmlFor="street-address"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {isEnglish ? "Preferred Hours" : "Präferierte Arbeitszeiten "}
              </label>
              <div>
                {TimerList(
                  isPrefTimeDisabled,
                  userDetails?.pref_time,
                  onChangetTime
                )}
              </div>
            </div>
          </div>

          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-3">
              <label
                htmlFor="permanent-branch"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                {access === EnumUserAcces.ADMIN || access === EnumUserAcces.DEV
                  ? isEnglish
                    ? "Permanent Branch"
                    : "Beschäftigungsort"
                  : isEnglish
                  ? "Permanent Branch:"
                  : "Beschäftigungsort:"}
              </label>
              {access === EnumUserAcces.ADMIN ||
              access === EnumUserAcces.DEV ? (
                BranchPicker(
                  props.array_branches,
                  props.fType === EnumPopupFunctions.ADD_USER
                    ? undefined
                    : userDetails?.permanant_branch.name,
                  "permanet-branch-picker",
                  isDisabled,
                  onBranchChange
                )
              ) : (
                <label
                  htmlFor="permanent-branch"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {props.fType === EnumPopupFunctions.ADD_USER
                    ? undefined
                    : userDetails?.permanant_branch.name}
                </label>
              )}
            </div>
          </div>
          {access === EnumUserAcces.EMPLOYEE ? (
            <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              <div className="sm:col-span-3">
                <label
                  htmlFor="temporary-branch-label"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Temporary Branch
                </label>

                {TemporaryBranch(
                  onTeamLeadChange,
                  sendRequest,
                  isJoiningRequest
                )}
                <div className="mt-2">
                  {joinRequestToast === EnumAlertDialogType.NEUTRAL
                    ? null
                    : joinRequestToast === EnumAlertDialogType.POSITIVE
                    ? PositiveToast("Request sent")
                    : NegativeToast(joinRequestMessage)}
                </div>
              </div>
            </div>
          ) : null}
        </div>

        {access === EnumUserAcces.ADMIN || access === EnumUserAcces.DEV
          ? AdminOnly(userDetails, isDisabled, onRoleChange, onUserToggle)
          : null}
      </div>

      <div className="mt-6 flex items-center justify-end gap-x-6">
        {issActivityIndicator === true ? ActivityIndicator(1) : null}
        <div className="">
          {isToastVisible === EnumAlertDialogType.POSITIVE ||
          isToastVisible === EnumAlertDialogType.NEGATIVE
            ? Toast(toastText, isToastVisible)
            : null}
        </div>
        <button
          onClick={onCancel}
          type="button"
          className="block rounded-md px-3 py-2 text-center text-sm font-semibold text-white shadow-sm bg-red-600 hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          //className="text-sm font-semibold leading-6 text-gray-900"
        >
          {isEnglish ? "back" : "Zurück"}
        </button>
        {props.fType === EnumPopupFunctions.USER_DETAIL ? null : (
          <button
            onClick={onSave}
            type="submit"
            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {isEnglish ? "Save" : "Speichern"}
          </button>
        )}
      </div>
    </div>
  );
}

function TimerList(
  isDisabled: boolean,
  array_prefTimes: PreferredTimeModel[] | undefined,
  onChangeTime: (item: PreferredTimeModel[]) => void
) {
  const isEnglish = getLanguage();
  function onChangeTimeItem(item_: PreferredTimeModel) {
    if (array_prefTimes !== undefined) {
      let tempItem: PreferredTimeModel[] = array_prefTimes;
      const itemIndex: number = tempItem.findIndex(
        (x) => x.day_key === item_.day_key
      );
      if (itemIndex !== -1) {
        tempItem[itemIndex] = item_;
      }
      onChangeTime(tempItem);
    }
  }
  return (
    <div>
      <table className="">
        <thead>
          <tr>
            <th
              scope="col"
              className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
            >
              {isEnglish ? "Day" : "Tag"}
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              {isEnglish ? "Start Time" : "Arbeitsbeginn"}
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            >
              {isEnglish ? "End Time" : "Arbeitsende"}
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {array_prefTimes?.map((x) =>
            CellPrefTime(isDisabled, x, onChangeTimeItem)
          )}
        </tbody>
      </table>
    </div>
  );
}

function CellPrefTime(
  isDisabled: boolean,
  item: PreferredTimeModel,
  onChangeTime: (item: PreferredTimeModel) => void
) {
  const isEnglish = getLanguage();
  function onChangeStartTime(value: string) {
    let temp: PreferredTimeModel = item;
    item.start_time = value;
    onChangeTime(temp);
  }
  function onChangeEndtTime(value: string) {
    let temp: PreferredTimeModel = item;
    item.end_time = value;
    onChangeTime(temp);
  }
  function onRemoveAvailability_() {
    let temp: PreferredTimeModel = item;
    item.start_time = "--:--";
    item.end_time = "--:--";
    onChangeTime(temp);
  }
  return (
    <tr key={item.day_key}>
      <td className="whitespace-nowrap pl-4 py-2 pr-3 text-sm sm:pl-0 font-semibold">
        {item.day_display}
      </td>
      <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
        <div className="relative">
          <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
            <svg
              className="w-4 h-4 text-gray-500 white:text-gray-400"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                clipRule="evenodd"
                fillRule="evenodd"
                d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z"
              />
            </svg>
          </div>
          <input
            type="time"
            id="start-time"
            className="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
            value={item.start_time}
            //defaultValue={item.start_time}
            onChange={(x) => onChangeStartTime(x.currentTarget.value)}
            disabled={isDisabled}
            required
          />
        </div>
      </td>
      <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
        <div className="relative">
          <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
            <svg
              className="w-4 h-4 text-gray-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                clipRule="evenodd"
                fillRule="evenodd"
                d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z"
              />
            </svg>
          </div>
          <input
            type="time"
            id="end-time"
            className="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
            value={item.end_time}
            //defaultValue={item.end_time}
            onChange={(x) => onChangeEndtTime(x.currentTarget.value)}
            disabled={isDisabled}
            required
          />
        </div>
      </td>
      {isDisabled ? null : (
        <td className="whitespace-nowrap pl-4 py-2 pr-3 text-sm sm:pl-0 font-semibold">
          <button
            onClick={onRemoveAvailability_}
            type="button"
            disabled={isDisabled}
            className="text-sm font-semibold leading-6 text-blue-700"
          >
            {isEnglish ? "Remove Availability" : "Verfügbarkeit löschen"}
          </button>
        </td>
      )}
    </tr>
  );
}

function BranchPicker(
  array_branches: BranchModel[],
  value_: string | undefined,
  pickerid: string,
  isDisabled: boolean,
  onBranchChange: (value: string) => void
) {
  const sIndex: number = array_branches.findIndex((x) => x.name === value_);
  let selectedBranch: BranchModel =
    sIndex !== -1
      ? array_branches[sIndex]
      : array_branches.length === 0
      ? noneBranchObject()
      : array_branches[array_branches.length - 1];
  function onBranch(bValue: string) {
    onBranchChange(bValue);
  }

  return (
    <div className="mt-2" key={pickerid}>
      <select
        id={"branch_" + pickerid}
        key={"selec-bp-" + pickerid}
        name="branch"
        autoComplete="branch-name"
        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
        defaultValue={selectedBranch.name}
        onChange={(x) => onBranch(x.currentTarget.value)}
        disabled={isDisabled}
      >
        {array_branches.map((x) => (
          <option key={pickerid + "bp-" + x.branch_id}>{x.name}</option>
        ))}
      </select>
    </div>
  );
}

function TemporaryBranch(
  onTeamLeadChange: (team_lead_email: string) => void,
  onSendRequest: () => void,
  isActivity: boolean
) {
  const isEnglish = getLanguage();

  function sendRequest() {
    onSendRequest();
  }
  function onTLChange(value: string) {
    onTeamLeadChange(value);
  }
  return (
    <div className="mt-2 flex flex-row">
      <label
        htmlFor="temp-branch"
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {/* {value_ !== null ? value_ : "Not Selected"} */}
      </label>

      <label
        htmlFor="temp-branch"
        className="block text-sm font-medium pl-5 pr-2 leading-6 text-gray-900"
      >
        {isEnglish ? "Team Lead ID" : "ID/E-Mail-Adresse des Teamleiters"}
      </label>
      <input
        type="text"
        name="street-address"
        id="tb-street-address"
        onChange={(x) => onTLChange(x.currentTarget.value)}
        autoComplete="street-address"
        className="block rounded-md pl-1 h-max border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-4"
      />
      <td className="whitespace-nowrap pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
        <div className="flex flex-row">
          <a
            onClick={sendRequest}
            href="#SendRquest"
            className="text-indigo-600 hover:text-indigo-900"
          >
            {isEnglish ? "Send Request" : "Anfrage senden"}
            <span className="sr-only">{", Send Request"}</span>
          </a>

          {isActivity ? (
            <div className="pl-5"> {ActivityIndicator(1)} </div>
          ) : null}
        </div>
      </td>
    </div>
  );
}

function AdminOnly(
  user: UserModel,
  isDisabled: boolean,
  onRoleChange: (value: string) => void,
  onUserToggle: (value: string) => void
) {
  const isEnglish = getLanguage();

  let array_roles = getUserRolesList();
  const ttlIndex = getUserRolesList().findIndex(
    (x) => x.type === EnumUserAcces.TEMP_TEAM_LEAD
  );
  if (ttlIndex !== -1) {
    array_roles.splice(ttlIndex, 1);
  }

  function onRoleChange_(value: string) {
    onRoleChange(value);
  }

  function onUserToggle_(value: string) {
    onUserToggle(value);
  }

  return (
    <div className="border-b border-gray-900/10 pb-12">
      <h2 className="text-base font-semibold leading-7 text-gray-900">
        {isEnglish ? "Admin only" : "Nur für den Administrator"}
      </h2>
      <p className="mt-1 text-sm leading-6 text-gray-600">
        {isEnglish
          ? "Set user type and its houry wage"
          : "Benutzergruppe und Stundenlohn"}
      </p>

      <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
        <div className="sm:col-span-3">
          <label
            htmlFor="user-type-label"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            {isEnglish ? "User Type" : "Anwender Art"}
          </label>
          <div className="mt-2">
            <select
              id="user-type"
              name="user-type"
              //autoComplete="user-type-name"
              disabled={isDisabled}
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
              defaultValue={user.role.display_name}
              onChange={(x) => onRoleChange_(x.currentTarget.value)}
            >
              {array_roles.map((x) => [
                <option key={x.id}>{x.display_name}</option>,
              ])}
            </select>
          </div>
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
        <div className="sm:col-span-3">
          <label
            htmlFor="user-type-label"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            {isEnglish
              ? "Toggle User Enable/Disable"
              : "Mitarbeiterstatus ändern"}
          </label>
          <div className="mt-2">
            <select
              id="user-type"
              name="user-type"
              //autoComplete="user-type-name"
              disabled={isDisabled}
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
              defaultValue={user.toggleAbility.display_name}
              onChange={(x) => onUserToggle_(x.currentTarget.value)}
            >
              {getUserToggleArray().map((x) => [
                <option key={x.key}>{x.display_name}</option>,
              ])}
            </select>
          </div>
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
        <div className="sm:col-span-4">
          <label
            htmlFor="email"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            {isEnglish ? "Hourly Rate" : "Stundenlohn"}
          </label>
          <div className="flex flex-row">
            <div className="mt-2 pl-1">
              <input
                id="hourly_rate"
                name="hourly_rate"
                type="number"
                placeholder={getCurrentCurrency()}
                disabled={isDisabled}
                className="block pl-1 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                onChange={(x) =>
                  (user.hourly_rate = Number(x.currentTarget.value))
                }
                defaultValue={user.hourly_rate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
